module.exports = __webpack_public_path__ + "static/media/logo--round--min.91213cbc.png";